import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { isAnalyticsAllowed } from './utils/cookieConsent';

const firebaseConfig = {
  apiKey: "AIzaSyCSU8ag6EFt-_sFIacx2cnSz7dHr6333KA",
  authDomain: "shipstation-automation.firebaseapp.com",
  databaseURL: "https://shipstation-automation.firebaseio.com",
  projectId: "shipstation-automation",
  storageBucket: "shipstation-automation.appspot.com",
  messagingSenderId: "1001207620336",
  appId: "1:1001207620336:web:ad95f15e72f61eaa4ad835",
  measurementId: "G-RK3752VZ18"
};

const app = initializeApp(firebaseConfig);
  
// Analytics instance - only initialized when user consents
let analytics = null;

/**
 * Initialize Firebase Analytics (only called after user consent)
 */
export const initAnalytics = () => {
  if (typeof window === 'undefined') return null;
  
  // Only initialize if not already initialized and user has consented
  if (!analytics && isAnalyticsAllowed()) {
    try {
      analytics = getAnalytics(app);
      console.log('✅ Firebase Analytics initialized with user consent');
    } catch (error) {
      console.warn('Analytics initialization failed:', error);
    }
  }
  
  return analytics;
};

/**
 * Get the analytics instance (may be null if not consented)
 */
export const getAnalyticsInstance = () => {
  return analytics;
};

/**
 * Check if analytics is ready to use
 */
export const isAnalyticsReady = () => {
  return analytics !== null;
};

// Listen for consent changes to initialize/disable analytics
if (typeof window !== 'undefined') {
  window.addEventListener('consentChanged', (event) => {
    const { level } = event.detail;
    if (level === 'all' && !analytics) {
      initAnalytics();
    }
  });
}

export { analytics, app };